'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _RadioStyled = require('./styles/RadioStyled');

var _RadioLabelStyled = require('./styles/RadioLabelStyled');

var _theme = require('../styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('radio', _theme2.default);
var nextId = 0;
var propTypes = {
  /**
   * Value of the radio
   */
  value: _propTypes2.default.any,

  /**
   * Determines whether radio is checked
   */
  checked: _propTypes2.default.bool,

  /**
   * Determines whether radio is checked by default
   */
  defaultChecked: _propTypes2.default.bool,

  /**
   * Determines whether radio is diables
   */
  disabled: _propTypes2.default.bool,

  /**
   * Determines label text of the radio
   */
  text: _propTypes2.default.string,

  /**
   * Specify function to call on radio value change
   */
  onChange: _propTypes2.default.func,

  /**
   * Item's index for group binding
   */
  index: _propTypes2.default.number
};
var defaultProps = {
  value: void 0,
  checked: void 0,
  defaultChecked: false,
  disabled: false,
  text: '',
  onChange: _reactackleCore.noop,
  index: 0
};

var Radio = exports.Radio = function (_Component) {
  _inherits(Radio, _Component);

  function Radio(props) {
    _classCallCheck(this, Radio);

    var _this = _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, props));

    _this._inputId = 'radio-' + nextId++;
    _this.state = {
      checked: (0, _reactackleCore.isUndef)(_this.props.checked) ? props.defaultChecked : _this.props.checked
    };
    _this._handleChange = _this._handleChange.bind(_this);
    return _this;
  }

  _createClass(Radio, [{
    key: '_handleChange',
    value: function _handleChange(event) {
      var checked = event.target.checked;
      this.props.onChange({
        value: this.props.value,
        index: this.props.index
      });
      if (this.props.checked === null) this.setState({
        checked: checked
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var checked = (0, _reactackleCore.isUndef)(this.props.checked) ? this.state.checked : this.props.checked;
      return _react2.default.createElement(_RadioStyled.RadioStyled, null, _react2.default.createElement('input', {
        id: this._inputId,
        type: 'radio',
        checked: checked,
        disabled: this.props.disabled,
        onChange: this._handleChange,
        tabIndex: '0'
      }), _react2.default.createElement(_RadioLabelStyled.RadioLabelStyled, {
        checked: checked,
        disabled: this.props.disabled,
        htmlFor: this._inputId
      }, this.props.text));
    }
  }]);

  return Radio;
}(_react.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
Radio.displayName = 'Radio';